import { render } from "./FormHome.vue?vue&type=template&id=7279b29d"
import script from "./FormHome.vue?vue&type=script&lang=js"
export * from "./FormHome.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Danben\\Proyectos\\Demos\\duchas-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__